import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiXCircle } from 'react-icons/fi';
import { validateShipmentTrackingNumber } from '../../../../helpers/formHelpers/formHelpers';
import { getQueryParam } from '../../../../helpers/url/urlHelpers';
import ISendReceipt from '../../../../interfaces/sendReceipt/sendReceipt';
import Button from '../../../base/button';
import { Input } from '../../../base/forms/input';
import { P } from '../../../base/typography';
import * as StyledTrackingNumber from './trackingNumber.styles';

interface Props {
	values: ISendReceipt;
	errors: any;
	setFieldValue: any;
	noQuery?: boolean;
}

const TrackingNumber: FC<Props> = ({ errors, setFieldValue, noQuery }) => {
	// const dispatch = useDispatch<any>();
	const { t } = useTranslation('sendReceipt');
	const query = noQuery ? '' : getQueryParam('q');
	const [trackingNumber, setTrackingNumber] = useState('');
	const [acceptedTrackingNumbers, setAcceptedTrackingNumbers] = useState([]);
	const [error, setError] = useState(false);
	const [haveCheckedQuery, setHaveCheckedQuery] = useState(false);

	const onChange = e => {
		setTrackingNumber(e.target.value);
	};

	const changeError = () => {
		setError(true);
		setTimeout(() => {
			setError(false);
		}, 3000);
	};
	const addTrackingNumber = () => {
		if (!validateShipmentTrackingNumber(trackingNumber)) {
			changeError();
		} else {
			acceptedTrackingNumbers.push(trackingNumber);
			setTrackingNumber('');
			setFieldValue('trackingNumbers', [...acceptedTrackingNumbers]);
			setAcceptedTrackingNumbers([...acceptedTrackingNumbers]);
		}
	};

	const removeAcceptedTrackingNumber = numberToRemove => {
		const indexToRemove = acceptedTrackingNumbers.findIndex(item => numberToRemove === item);
		acceptedTrackingNumbers.splice(indexToRemove, 1);
		setFieldValue('trackingNumbers', [...acceptedTrackingNumbers]);
		setAcceptedTrackingNumbers([...acceptedTrackingNumbers]);
	};

	useEffect(() => {
		if (query && acceptedTrackingNumbers.length === 0 && !haveCheckedQuery) {
			setHaveCheckedQuery(true);
			if (!validateShipmentTrackingNumber(query)) {
				setTrackingNumber(query);
				changeError();
			} else {
				acceptedTrackingNumbers.push(query.toUpperCase());
				setTrackingNumber('');
				setFieldValue('trackingNumbers', [...acceptedTrackingNumbers]);
				setAcceptedTrackingNumbers([...acceptedTrackingNumbers]);
			}
		}
	}, [query, setTrackingNumber, setHaveCheckedQuery, setFieldValue, acceptedTrackingNumbers, haveCheckedQuery]);

	return (
		<StyledTrackingNumber.Wrapper>
			<StyledTrackingNumber.TrackingNumberWrapper>
				<Input
					type="text"
					value={trackingNumber}
					onChange={onChange}
					onKeyUp={e => e.key === 'Enter' && addTrackingNumber()}
					placeholder={`${t('enter-shipment-code')}...`}
				/>
				<StyledTrackingNumber.ButtonWrapper>
					<Button type="button" primary mobileBlock onClick={addTrackingNumber}>
						{acceptedTrackingNumbers.length > 0 ? t('add-trackingnumber') : t('confirm-trackingnumber')}
					</Button>
				</StyledTrackingNumber.ButtonWrapper>
			</StyledTrackingNumber.TrackingNumberWrapper>
			{error && (
				<StyledTrackingNumber.StyledErrorMessage>
					{t('errorWithTrackingnumber')}
				</StyledTrackingNumber.StyledErrorMessage>
			)}
			{errors.trackingNumbers && (
				<StyledTrackingNumber.StyledErrorMessage>
					{t(errors.trackingNumbers)}
				</StyledTrackingNumber.StyledErrorMessage>
			)}
			<StyledTrackingNumber.AcceptedTrackingNumbers>
				{acceptedTrackingNumbers &&
					acceptedTrackingNumbers.map((item, index) => (
						<StyledTrackingNumber.AcceptedTrackingNumber key={index}>
							<P>{item}</P>
							<FiXCircle onClick={() => removeAcceptedTrackingNumber(item)} />
						</StyledTrackingNumber.AcceptedTrackingNumber>
					))}
			</StyledTrackingNumber.AcceptedTrackingNumbers>
		</StyledTrackingNumber.Wrapper>
	);
};

export default TrackingNumber;
